import { render, staticRenderFns } from "./SubChannelSelector.vue?vue&type=template&id=4e3a2804&"
import script from "./SubChannelSelector.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubChannelSelector.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports